import axios from "axios";

const getRequestHeaders = (): Record<string, string | undefined> => {
  const urlParams = new URLSearchParams(window.location.search);
  const authContextID = urlParams.get("session_id");
  const emrUserID = urlParams.get("emr_user_id");
  const parsedUrl = new URL(window.location.href);

  // Check both URL fragments and query params for access token
  const fragments = new URLSearchParams(parsedUrl.hash.substring(1));
  const accessToken = fragments.get("access_token");
  const idToken = urlParams.get("id_token");
  const emrUserName = urlParams.get("emr_user_full_name");
  const server_url = urlParams.get("iss");
  const jwks_uri = urlParams.get("jwks_uri");

  const headers: Record<string, string | undefined> = {
    "auth-context-id": authContextID,
    "emr-user-id": emrUserID,
    "emr-user-name": emrUserName,
    "x-fhir-server": server_url,
    "x-fhir-jwks-uri": jwks_uri,
  };

  if (accessToken) {
    headers["Authorization"] = `Bearer ${accessToken}`;
  }
  if (idToken) {
    headers["Authorization"] = `Bearer ${idToken}`;
  }

  return headers;
};

const resolveUrl = () => {
  const host = window.location.hostname;
  // running locally
  if (host.includes("localhost") || host.includes("127.0.0.1")) {
    return process.env.REACT_APP_API_PATH;
  }
  const hostClean = host.replace("-cdn", "");
  return `https://${hostClean}${process.env.REACT_APP_API_PATH}`;
};

const api: any = axios.create({
  baseURL: resolveUrl(),
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFTOKEN",
});

// Attach the headers automatically
api.interceptors.request.use((config) => {
  config.headers = {
    ...getRequestHeaders(),
    ...config.headers,
  };
  return config;
});

export default api;
